/**
 * Legacy Test API
 * Adapter for converting old Vortex tests to health checks
 */
export function createLegacyApi(adapter, registry) {
    return {
        /**
         * Register a legacy test and convert it to a health check
         * @param id - Test ID
         * @param eventType - Event that triggers the test
         * @param check - Check function (legacy format)
         * @param category - Optional category classification
         */
        registerTest: (id, eventType, check, category) => {
            const legacyCheck = adapter.createLegacyHealthCheck(id, eventType, check, category);
            registry.register(legacyCheck);
        },
    };
}
